export enum GrantApplicationStatus {
  None = "none",
  SentForApproval = "sent_for_approval",
  BudgetApproved = "budget_approved",
  CostAdded = "cost_added",
  CostApproved = "cost_approved",
  Rejected = "rejected",
}
